var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderRightArrIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13,
    viewBox: "0 0 30 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 6.5C22.2471 7.34615 20.1108 8.5085 17.3059 12C19.2824 8.38571 22.0824 6.5 29 6.5Z",
    fill: "#2E301B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6.5C22.2471 5.65385 20.1108 4.4915 17.3059 1C19.2824 4.61429 22.0824 6.5 29 6.5Z",
    fill: "#2E301B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00006 6.5L29 6.5M29 6.5C22.2471 5.65385 20.1108 4.4915 17.3059 1C19.2824 4.61429 22.0824 6.5 29 6.5ZM29 6.5C22.2471 7.34615 20.1108 8.5085 17.3059 12C19.2824 8.38571 22.0824 6.5 29 6.5Z",
    stroke: "#2E301B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRightArrIc);
export default __webpack_public_path__ + "static/media/sliderRightArr_ic.d7497ac13fbc3304d05c914aac2da474.svg";
export { ForwardRef as ReactComponent };